<template>
    <div class="form-area">
        <Form style="width: 900px" ref="formInfoValidate" :rules="rules" :model="info" :label-width="100"
              label-position="left" inline>
            <FormItem label="表名" prop="tableName" :label-width="70" class="table-class">
                <Tooltip content="使用英文字母、数字、下划线组合" style="width: 30px">
                    <Icon type="ios-information-circle" />
                </Tooltip>
                <Input class="input-width" v-model.trim="info.tableName"></Input>
            </FormItem>
            <FormItem label="表单名称" prop="tableContent">
                <Input class="input-width" v-model.trim="info.tableContent"></Input>
            </FormItem>
            <FormItem label="包名" prop="packageName">
                <Input class="input-width" v-model.trim="info.packageName"></Input>
            </FormItem>
            <FormItem label="表单类型" prop="formType">
                <Select v-model="info.formType" style="width:300px">
                    <Option :value="0">单表</Option>
                    <Option :value="3">工作流表单</Option>
                </Select>
            </FormItem>
            <FormItem label="主键策略" prop="keyType">
                <Select v-model="info.keyType" style="width:300px">
                    <Option :value="0">自增ID</Option>
                </Select>
            </FormItem>
            <FormItem label="持久化类型" prop="persistenceType">
                <Select v-model="info.persistenceType" style="width:300px">
                    <Option :value="0">mybatis</Option>
                </Select>
            </FormItem>
            <FormItem label="表单模板" prop="formSuite">
                <Select v-model="info.formSuite" style="width:300px">
                    <Option v-for="(item,index) in suiteArr" :value="item.id" :key="index">{{item.suiteCode + ' ('+
                        item.suiteVersion +')'}}
                    </Option>
                </Select>
            </FormItem>
            <FormItem label="数据库类型" prop="dbType">
                <Select v-model="info.dbType" style="width:300px">
                    <Option :value="0">MYSQL</Option>
                </Select>
            </FormItem>
        </Form>
    </div>
</template>

<script>

export default {
  name: 'FormInfo',
  data () {
    let validateTableName = (rule, value, callback) => {
      let pattern = /^[_A-Za-z0-9]+$/
      if (value.length > 30) {
        callback(new Error('表名不可以超过30位'))
        return
      }
      if (!pattern.test(value)) {
        callback(new Error('表名必须是数字或字母或下划线'))
        return
      }
      const [url, httpConfig] = [
        '/api/validation/formTable',
        {
          params: { name: value }
        }
      ]
      if (value !== this.formName) {
        this.$http.get(url, httpConfig).then(response => {
          if (response.data.code === -1) {
            callback(new Error(response.data.msg))
          } else {
            callback()
          }
        }).catch(() => {
          callback(new Error('异步校验出错！'))
        })
      } else {
        callback()
      }
    }
    return {
      formName: null,
      rules: {
        tableName: [
          { required: true, message: '请输入表名', trigger: 'blur' },
          { validator: validateTableName, trigger: 'blur' }
        ],
        tableContent: [
          { required: true, message: '请输入表单名称', trigger: 'blur' },
          { max: 50, message: '表单名称不可以超过50位', trigger: 'blur' }
        ],
        packageName: [
          { required: true, message: '请输入包名', trigger: 'blur' },
          { max: 50, message: '包名长度不可以超过50位', trigger: 'blur' }
        ],
        formType: [
          { required: true, message: '请选择表单类型', trigger: 'change', type: 'number' }
        ],
        persistenceType: [
          { required: true, message: '请选择持久化类型', trigger: 'change', type: 'number' }
        ],
        keyType: [
          { required: true, message: '请选择主键策略', trigger: 'change', type: 'number' }
        ],
        formSuite: [
          { required: true, message: '请选择表单模板', trigger: 'change', type: 'number' }
        ],
        dbType: [
          { required: true, message: '请选择数据库类型', trigger: 'change', type: 'number' }
        ]
      }
    }
  },
  props: {
    info: Object,
    suiteArr: Array
  },
  watch: {
    info (value) {
      this.formName = value.tableName
    }
  },
  mounted () {

  },
  methods: {}
}
</script>

<style scoped lang="less">

    .input-width {
        width: 300px;
    }

    .form-area {
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }

    .table-class{
      ::v-deep .ivu-form-item-error-tip {
        left: 30px;
      }
    }

</style>
<style>
    .tooltip-form .ivu-form-item-error-tip{
        left: 50px;
    }
</style>
